import React, { Component } from 'react';
import FormControl from 'react-bootstrap/FormControl';
import { Popup } from '../../helpers/BootstrapHelpers';
import CadeResourceIcons from '../CadeResource/CadeResourceIcons';

import { isNullOrEmpty } from '../../helpers/LanguageHelpers';

class CadeDomainItem extends Component {

    onChangeHandler = (assessmentItemId, isCaregiver, isRater1, isRater2, isRater3, isPartnerProvider, event) => {
        if (!this.props.readonly) {
            this.props.changeHandler(assessmentItemId, isCaregiver, isRater1, isRater2, isRater3, isPartnerProvider, event);
        }
    }

    render() {
        let isCaregiverOrRater = this.props.isCaregiver || this.props.isRater1 || this.props.isRater2 || this.props.isRater3;
        let value = null;
        if (this.props.isCaregiver) {
            value = this.props.caregiverResponse;
        }
        else if (this.props.isRater1) {
            value = this.props.rater1Response;
        }
        else if (this.props.isRater2) {
            value = this.props.rater2Response;
        }
        else if (this.props.isRater3) {
            // Rater3 maps onto caregiver.  Just a name change.
            value = this.props.caregiverResponse;
        }
        else if (this.props.isPartnerProvider) {
            value = this.props.partnerProviderResponse;
        }
        else {
            value = this.props.cadeAiUserResponse;
        }

        if (isCaregiverOrRater) {
            return (
                <tr>
                    <td>{this.props.area}</td>
                    <td>
                        <span className={this.props.textClass}>{this.props.text}</span>
                        {!isNullOrEmpty(this.props.desc) &&
                            <Popup id={this.props.itemDefId} title={this.props.area} content={this.props.desc} placement="bottom" />
                        }
                    </td>
                    <td>
                        <FormControl
                            as="select"
                            title={this.props.area}
                            value={value}
                            onChange={this.onChangeHandler.bind(this, this.props.assessmentItemId, this.props.isCaregiver, this.props.isRater1, this.props.isRater2, this.props.isRater3, this.props.isPartnerProvider)}
                        >
                            <option>No Concern</option>
                            <option>Mild</option>
                            <option>Moderate</option>
                            <option>Significant</option>
                            <option>Don't Know</option>
                            <option></option>
                        </FormControl>
                    </td>
                    <td>
                        <CadeResourceIcons
                            resKey={this.props.itemDefId}
                            resources={this.props.resources}
                            clickHandler={this.props.resClickHandler}
                            size={32}
                        />
                    </td>
                </tr>
            )
        }
        else {
            return (
                <tr>
                    <td>{this.props.area}</td>
                    <td>
                        <span className={this.props.textClass}>{this.props.text}</span>
                        {!isNullOrEmpty(this.props.desc) &&
                            <Popup id={this.props.itemDefId} title={this.props.area} content={this.props.desc} placement="bottom" />
                        }
                    </td>
                    <td>
                        {!this.props.readonly &&
                            <FormControl
                                as="select"
                                title={this.props.area}
                                value={value}
                                onChange={this.onChangeHandler.bind(this, this.props.assessmentItemId, this.props.isCaregiver, this.props.isRater1, this.props.isRater2, this.props.isRater3, this.props.isPartnerProvider)}
                            >
                                <option>No Concern</option>
                                <option>Mild</option>
                                <option>Moderate</option>
                                <option>Significant</option>
                                <option>Don't Know</option>
                                <option></option>
                            </FormControl>
                        }

                        {this.props.readonly &&
                            <span>{value}</span>
                        }
                    </td>

                    {!this.props.isPartnerProvider &&
                        <td title={this.props.partnerProviderName}>{this.props.partnerProviderResponse}</td>
                    }

                    <td title={this.props.rater1Id}>{this.props.rater1Response}</td>
                    <td title={this.props.rater2Id}>{this.props.rater2Response}</td>
                    <td title={this.props.rater3Id}>{this.props.caregiverResponse}</td>

                    <td>
                        <CadeResourceIcons
                            resKey={this.props.itemDefId}
                            resources={this.props.resources}
                            clickHandler={this.props.resClickHandler}
                            size={32}
                        />
                    </td>
                </tr>
            )
        }
    }
}

export default CadeDomainItem;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeDomainItem.js